import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M17 4h-3V2h-4v2H7v10.5h2L13 7v5.5h2l-1.07 2H17V4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 20v-5.5H7V22h10v-7.5h-3.07L11 20z"
})), 'BatteryCharging30Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BatteryCharging30Sharp.js
// module id = 2286
// module chunks = 2